import { requiredStpForTarget } from "../../engine/calculations";

const config = {
  key: "req-stp",
  title: "STP Required For Target FV",
  category: "Target-Based",
  description: "Find the monthly transfer amount your Systematic Transfer Plan needs to hit a target.",
  fields: [
    { key: "targetFV", label: "Target future value", type: "currency", default: 25_00_000, min: 1000, max: 100_00_00_000 },
    { key: "sourceRate", label: "Source fund return", type: "percent", default: 7, min: 0, max: 20, assumptionKey: "debtReturn" },
    { key: "targetRate", label: "Target fund return", type: "percent", default: 12, min: 0, max: 30, assumptionKey: "equityReturn" },
    { key: "months", label: "Transfer period (months)", type: "number", default: 36, min: 1, max: 480 },
  ],
  compute(values) {
    const targetFV = Number(values.targetFV) || 0;
    const sourceRate = (Number(values.sourceRate) || 0) / 100;
    const targetRate = (Number(values.targetRate) || 0) / 100;
    const months = Math.round(Number(values.months) || 0);

    const requiredMonthlyTransfer = requiredStpForTarget(targetFV, sourceRate, targetRate, months);

    return {
      headline: { label: "Required monthly transfer", value: requiredMonthlyTransfer },
      breakdown: [{ label: "Target future value", value: targetFV }],
    };
  },
};

export default config;
